import React from "react";
import "./Banner.css";
import { Link } from "react-router-dom";

function Banner() {
  return (
    <Link to={"/products"}>
      <section className="home_banner">
        <div className="container-fluid p-0">
          <div className="img_holder">
            <img className="home_banner_img"
              src={
                process.env.PUBLIC_URL +
                "/assets/images/home/banner/banner_img_1.png"
              }
              alt="banner img" />
          </div>
        </div>
      </section>
    </Link>
  );
}

export default Banner;
